/** @jsxImportSource @emotion/react */
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from "prop-types";
import { SORT_DIRECTION } from "constants/common";
import SortIndicator from "components/common/SortIndicator";
import { gap4Css } from "./index.css";

export default function SortButton({ onClick, children, isSorted, sortDir, className, ...rest }) {
  return (
    <button
      type="button"
      css={gap4Css}
      className="inline-flex flex-a-c-j-st"
      onClick={onClick}
      {...rest}
    >
      <span className={`main-text-grey${className ? ` ${className}` : ""}`}>{children}</span>

      <SortIndicator isSorted={isSorted} sortDir={sortDir} />
    </button>
  );
}

SortButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  isSorted: PropTypes.bool,
  sortDir: PropTypes.oneOf(SORT_DIRECTION),
};
